<template>
    <div class="row dashboard">
        <div class="row">
            <div class="col-lg-12 important-announcement">
                <el-alert
                    title="Please note, the portal will not allow deliveries to be scheduled when invoices are past due and have turned yellow. Please pay all invoices within the net days allowed. Credit card processing fees may apply, no fees will apply to ACH payments."
                    class="mb-3"
                    :closable="false"
                    type="warning"
                />
            </div>
        </div>
        <div class="col-6">
            <el-alert
                title="Effective immediately we will be adding a 10% fuel surcharge to all delivery fees"
                show-icon
                class="mb-3"
                :closable="false"
                type="warning"
            />
        </div>
        <div class="col-6"></div>
        <div class="col-12">
            <div class="px-0 col-lg-6 col-12">
                <card>
                    <h2 class="card-title">2025 Rate Sheets</h2>
                    <el-collapse v-model="rateSheetsOpen">
                        <el-collapse-item title="View Rate Sheets" name="one">
                            <p class="info">
                                The 2024 rate sheets will remain in effect for
                                all orders placed prior to Jaunuary 1, 2025.
                            </p>
                            <div class="d-block">
                                <base-button
                                    :class="$style.rateSheetButton"
                                    link
                                    type="primary"
                                    @click="downloadCabinetRateSheet"
                                >
                                    Download 2025 Cabinet Rate Sheet
                                </base-button>
                            </div>
                            <div class="d-block">
                                <base-button
                                    :class="$style.rateSheetButton"
                                    link
                                    type="primary"
                                    @click="downloadFurnitureRateSheet"
                                >
                                    Download 2025 Furniture Rate Sheet
                                </base-button>
                            </div>
                            <div class="d-block">
                                <base-button
                                    :class="$style.rateSheetButton"
                                    link
                                    type="primary"
                                    @click="downloadBaseRateSheet"
                                >
                                    Download 2025 Base Rate Sheet
                                </base-button>
                            </div>
                        </el-collapse-item>
                    </el-collapse>
                </card>
                <cabinet-terms-and-conditions-modal
                    :show.sync="showCabinetTermsAndConditions"
                />
                <furniture-terms-and-conditions-modal
                    :show.sync="showFurnitureTermsAndConditions"
                />
            </div>
        </div>
        <div
            v-for="card in stats"
            :key="card.subTitle"
            class="col-lg-3 col-md-6"
        >
            <stats-card
                :title="card.title"
                :sub-title="card.subTitle"
                :type="card.type"
                :icon="card.icon"
                :link="card.link"
            >
                <div
                    v-if="card.footer"
                    slot="footer"
                    v-html="card.footer"
                ></div>
            </stats-card>
        </div>
        <div class="col-12">
            <el-tabs v-model="activeTab" type="border-card">
                <el-tab-pane label="Delivery Requests" name="one">
                    <delivery-requests />
                </el-tab-pane>
                <el-tab-pane label="Future Delivery Requests" name="two">
                    <future-delivery-requests v-if="futureTabLoaded" />
                </el-tab-pane>
            </el-tabs>
        </div>
    </div>
</template>

<script>
import { Alert, Tabs, TabPane, Collapse, CollapseItem } from "element-ui";
import StatsCard from "src/components/UI/Cards/StatsCard";
import DeliveryRequests from "src/modules/DeliveryRequest/DeliveryRequests";
import FutureDeliveryRequests from "src/modules/FutureDeliveryRequest/FutureDeliveryRequests";
import CabinetTermsAndConditionsModal from "src/modules/DeliveryRequest/NewDeliveryRequest/_components/CabinetTermsAndConditionsModal";
import FurnitureTermsAndConditionsModal from "src/modules/DeliveryRequest/NewDeliveryRequest/_components/FurnitureTermsAndConditionsModal";

export default {
    name: "Dashboard",
    components: {
        DeliveryRequests,
        FutureDeliveryRequests,
        StatsCard,
        CabinetTermsAndConditionsModal,
        FurnitureTermsAndConditionsModal,
        [Alert.name]: Alert,
        [Tabs.name]: Tabs,
        [TabPane.name]: TabPane,
        [Collapse.name]: Collapse,
        [CollapseItem.name]: CollapseItem,
    },
    props: {
        stats: {
            type: Array,
            required: true,
        },
    },
    data() {
        return {
            rateSheetsOpen: "",
            activeTab: "one",
            futureTabLoaded: false,
            showCabinetTermsAndConditions: false,
            showFurnitureTermsAndConditions: false,
        };
    },
    watch: {
        activeTab(newVal) {
            if (newVal === "two") {
                this.futureTabLoaded = true;
            }
        },
    },
    methods: {
        downloadBaseRateSheet() {
            this.$emit("downloadFile", {
                downloadName: "Base Rates 2025 - Delivery By Design.pdf",
                url: "downloads/base_rates_2025.pdf",
            });
        },
        downloadCabinetRateSheet() {
            this.$emit("downloadFile", {
                downloadName: "Cabinet Rates 2025 - Delivery By Design.pdf",
                url: "downloads/cabinet_rates_2025.pdf",
            });
        },
        downloadFurnitureRateSheet() {
            this.$emit("downloadFile", {
                downloadName: "Furniture Rates 2025 - Delivery By Design.pdf",
                url: "downloads/furniture_rates_2025.pdf",
            });
        },
    },
};
</script>

<style module>
.rateSheetButton {
    font-size: 18px;
}
</style>
